// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-btn {
  display: inline-block;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  border: 1px solid #2b70fa;
  padding: 0 30px;
  font-size: 15px;
  line-height: 45px;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
  z-index: 5;
  transition: all 0.4s ease-out 0s;
  background-color: #2b70fa;
}
.main-btn:hover {
  background-color: #fff;
  color: #2b70fa;
  border-color: #2b70fa;
}
.main-btn.main-btn-2 {
  background-color: #fff;
  color: #2b70fa;
  border-color: #2b70fa;
}
.main-btn.main-btn-2:hover {
  background-color: #2b70fa;
  border-color: #2b70fa;
  color: #fff;
}

.appie-section-title {
  padding-bottom: 25px;
}
.appie-section-title .appie-title {
  font-size: 44px;
  line-height: 54px;
}
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .appie-section-title .appie-title {
    font-size: 36px;
    line-height: 46px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .appie-section-title .appie-title {
    font-size: 36px;
    line-height: 46px;
  }
}
@media (max-width: 767px) {
  .appie-section-title .appie-title {
    font-size: 26px;
    line-height: 36px;
  }
}
@media only screen and (min-width: 576px) and (max-width: 767px) {
  .appie-section-title .appie-title {
    font-size: 36px;
    line-height: 46px;
  }
}
.appie-section-title p {
  font-size: 18px;
  line-height: 28px;
  margin-top: 11px;
}
@media only screen and (min-width: 992px) and (max-width: 1200px) {
  .appie-section-title p {
    font-size: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .appie-section-title p {
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .appie-section-title p {
    font-size: 15px;
  }
}
.appie-section-title .main-btn {
  border-radius: 30px;
  border: 2px solid #e7eaef;
  background: #fff;
  color: #0e1133;
}
.appie-section-title .main-btn:hover {
  background: #ff3e66;
  color: #fff;
  border-color: #ff3e66;
}
.appie-section-title.appie-section-title-2 .appie-title {
  color: #fff;
}
.appie-section-title.appie-section-title-2 p {
  color: #fff;
}

.back-to-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 999;
  display: none;
}
.back-to-top a {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 40px;
  background: #2b70fa;
  border-radius: 6px;
  color: #fff;
}
.back-to-top.back-to-top-2 a {
  background: #ff3e66;
}
.back-to-top.back-to-top-3 a {
  background: #ff6b58;
}
.back-to-top.back-to-top-6 a {
  background: #9b2cfa;
}
.back-to-top.back-to-top-5 a {
  background: #801f82;
}
.back-to-top.back-to-top-8 a {
  background: #db0f30;
}

.off_canvars_overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9998;
  opacity: 0;
  visibility: hidden;
  cursor: crosshair;
  background: #232323;
  top: 0;
  transition: all linear 0.3s;
}
.off_canvars_overlay.active {
  opacity: 0.5;
  visibility: visible;
}

.offcanvas_menu {
  display: none;
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .offcanvas_menu {
    display: block;
  }
}
@media (max-width: 767px) {
  .offcanvas_menu {
    display: block;
  }
}

.offcanvas_menu_wrapper {
  width: 290px;
  position: fixed;
  background: #fff;
  z-index: 9999;
  top: 0;
  height: 100%;
  transition: 0.5s;
  left: 0;
  margin-left: -300px;
  padding: 50px 15px 30px;
  overflow-y: visible;
}
.offcanvas_menu_wrapper.active {
  margin-left: 0;
}
.offcanvas_menu_wrapper .slinky-theme-default {
  background: inherit;
  min-height: 300px;
  overflow-y: auto;
}
.offcanvas_menu_wrapper .header-btn {
  margin-bottom: 30px;
}
.offcanvas_menu_wrapper .header-btn a {
  color: #222;
}
.offcanvas_menu_wrapper .header-btn a:hover {
  color: #222;
}

.offcanvas_main_menu li {
  position: relative;
}
.offcanvas_main_menu li:last-child {
  margin: 0;
}
.offcanvas_main_menu li span.menu-expand {
  position: absolute;
  right: 0;
}
.offcanvas_main_menu li a {
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize;
  display: block;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #ededed;
  color: #222;
  transition: all 0.3s ease-out 0s;
}
.offcanvas_main_menu li a:hover {
  color: #2b70fa;
}
.offcanvas_main_menu li ul.sub-menu {
  padding-left: 20px;
}

.offcanvas_footer {
  padding-bottom: 50px;
  text-align: center;
}
.offcanvas_footer span a {
  font-size: 14px;
  color: #222;
  transition: all 0.3s ease-out 0s;
}
.offcanvas_footer span a:hover {
  color: #2b70fa;
}

.offcanvas_menu_wrapper.active .canvas_close {
  opacity: 1;
  visibility: visible;
}

.canvas_close {
  position: absolute;
  top: 10px;
  right: -50px;
  opacity: 0;
  visibility: hidden;
  transition: all linear 0.3s;
}
.canvas_close a {
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 500;
  width: 40px;
  height: 40px;
  display: block;
  text-align: center;
  line-height: 40px;
  border: 1px solid #2b70fa;
  border-radius: 10px;
  background: #2b70fa;
  color: #fff;
  transition: all 0.3s ease-out 0s;
}
.canvas_close a:hover {
  background: #2b70fa;
  border-color: #2b70fa;
  color: #fff;
}

.canvas_open a {
  font-size: 26px;
  width: 50px;
  height: 42px;
  display: block;
  line-height: 39px;
  text-align: center;
  border: 1px solid #232323;
  color: #222;
  transition: all 0.3s ease-out 0s;
}
.canvas_open a:hover {
  color: #2b70fa;
  border-color: #2b70fa;
}

.offcanvas-social {
  margin-bottom: 40px;
  margin-top: 40px;
}
.offcanvas-social ul li {
  display: inline-block;
}
.offcanvas-social ul li a {
  height: 40px;
  width: 40px;
  text-align: center;
  line-height: 38px;
  color: #2b70fa;
  border: 1px solid #eaeaea;
  border-radius: 50%;
  margin: 0 5px;
  transition: all 0.3s ease-out 0s;
}
.offcanvas-social ul li a:hover {
  background: #2b70fa;
  border-color: #2b70fa;
  color: #fff;
}

.toggle-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 20px;
  color: #0e1133;
}

.preloader {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-position: center center;
  background-repeat: no-repeat;
 /* background-image: url(../../img/icons/preloader.svg);*/
}

.preloader-close {
  position: fixed;
  z-index: 999999;
  color: #fff;
  padding: 10px 20px;
  cursor: pointer;
  right: 40px;
  bottom: 40px;
  font-weight: 600;
  line-height: 60px;
  background: #2b70fa;
  padding: 0 15px;
  border-radius: 5px;
}

.loader-wrap {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  z-index: 999999;
}

.loader-wrap .layer-one {
  position: absolute;
  left: 0%;
  top: 0;
  width: 33.3333%;
  height: 100%;
  overflow: hidden;
}

.loader-wrap .layer-two {
  position: absolute;
  left: 33.3333%;
  top: 0;
  width: 33.3333%;
  height: 100%;
  overflow: hidden;
}

.loader-wrap .layer-three {
  position: absolute;
  left: 66.6666%;
  top: 0;
  width: 33.3333%;
  height: 100%;
  overflow: hidden;
}

.loader-wrap .layer .overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #f4f9ff;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/drawer.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,UAAU;EAKV,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,MAAM;EACN,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,WAAW;EAKX,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EAKX,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EAKX,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EAKX,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EAKb,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kCAAkC;EAClC,4BAA4B;CAC7B,yDAAyD;AAC1D;;AAEA;EACE,eAAe;EACf,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".main-btn {\n  display: inline-block;\n  font-weight: 500;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  border: 1px solid #2b70fa;\n  padding: 0 30px;\n  font-size: 15px;\n  line-height: 45px;\n  border-radius: 6px;\n  color: #fff;\n  cursor: pointer;\n  z-index: 5;\n  -webkit-transition: all 0.4s ease-out 0s;\n  -moz-transition: all 0.4s ease-out 0s;\n  -ms-transition: all 0.4s ease-out 0s;\n  -o-transition: all 0.4s ease-out 0s;\n  transition: all 0.4s ease-out 0s;\n  background-color: #2b70fa;\n}\n.main-btn:hover {\n  background-color: #fff;\n  color: #2b70fa;\n  border-color: #2b70fa;\n}\n.main-btn.main-btn-2 {\n  background-color: #fff;\n  color: #2b70fa;\n  border-color: #2b70fa;\n}\n.main-btn.main-btn-2:hover {\n  background-color: #2b70fa;\n  border-color: #2b70fa;\n  color: #fff;\n}\n\n.appie-section-title {\n  padding-bottom: 25px;\n}\n.appie-section-title .appie-title {\n  font-size: 44px;\n  line-height: 54px;\n}\n@media only screen and (min-width: 992px) and (max-width: 1200px) {\n  .appie-section-title .appie-title {\n    font-size: 36px;\n    line-height: 46px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .appie-section-title .appie-title {\n    font-size: 36px;\n    line-height: 46px;\n  }\n}\n@media (max-width: 767px) {\n  .appie-section-title .appie-title {\n    font-size: 26px;\n    line-height: 36px;\n  }\n}\n@media only screen and (min-width: 576px) and (max-width: 767px) {\n  .appie-section-title .appie-title {\n    font-size: 36px;\n    line-height: 46px;\n  }\n}\n.appie-section-title p {\n  font-size: 18px;\n  line-height: 28px;\n  margin-top: 11px;\n}\n@media only screen and (min-width: 992px) and (max-width: 1200px) {\n  .appie-section-title p {\n    font-size: 15px;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .appie-section-title p {\n    font-size: 15px;\n  }\n}\n@media (max-width: 767px) {\n  .appie-section-title p {\n    font-size: 15px;\n  }\n}\n.appie-section-title .main-btn {\n  border-radius: 30px;\n  border: 2px solid #e7eaef;\n  background: #fff;\n  color: #0e1133;\n}\n.appie-section-title .main-btn:hover {\n  background: #ff3e66;\n  color: #fff;\n  border-color: #ff3e66;\n}\n.appie-section-title.appie-section-title-2 .appie-title {\n  color: #fff;\n}\n.appie-section-title.appie-section-title-2 p {\n  color: #fff;\n}\n\n.back-to-top {\n  position: fixed;\n  right: 30px;\n  bottom: 30px;\n  z-index: 999;\n  display: none;\n}\n.back-to-top a {\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  line-height: 40px;\n  background: #2b70fa;\n  border-radius: 6px;\n  color: #fff;\n}\n.back-to-top.back-to-top-2 a {\n  background: #ff3e66;\n}\n.back-to-top.back-to-top-3 a {\n  background: #ff6b58;\n}\n.back-to-top.back-to-top-6 a {\n  background: #9b2cfa;\n}\n.back-to-top.back-to-top-5 a {\n  background: #801f82;\n}\n.back-to-top.back-to-top-8 a {\n  background: #db0f30;\n}\n\n.off_canvars_overlay {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 9998;\n  opacity: 0;\n  visibility: hidden;\n  cursor: crosshair;\n  background: #232323;\n  top: 0;\n  transition: all linear 0.3s;\n}\n.off_canvars_overlay.active {\n  opacity: 0.5;\n  visibility: visible;\n}\n\n.offcanvas_menu {\n  display: none;\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .offcanvas_menu {\n    display: block;\n  }\n}\n@media (max-width: 767px) {\n  .offcanvas_menu {\n    display: block;\n  }\n}\n\n.offcanvas_menu_wrapper {\n  width: 290px;\n  position: fixed;\n  background: #fff;\n  z-index: 9999;\n  top: 0;\n  height: 100%;\n  transition: 0.5s;\n  left: 0;\n  margin-left: -300px;\n  padding: 50px 15px 30px;\n  overflow-y: visible;\n}\n.offcanvas_menu_wrapper.active {\n  margin-left: 0;\n}\n.offcanvas_menu_wrapper .slinky-theme-default {\n  background: inherit;\n  min-height: 300px;\n  overflow-y: auto;\n}\n.offcanvas_menu_wrapper .header-btn {\n  margin-bottom: 30px;\n}\n.offcanvas_menu_wrapper .header-btn a {\n  color: #222;\n}\n.offcanvas_menu_wrapper .header-btn a:hover {\n  color: #222;\n}\n\n.offcanvas_main_menu li {\n  position: relative;\n}\n.offcanvas_main_menu li:last-child {\n  margin: 0;\n}\n.offcanvas_main_menu li span.menu-expand {\n  position: absolute;\n  right: 0;\n}\n.offcanvas_main_menu li a {\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: capitalize;\n  display: block;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid #ededed;\n  color: #222;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.offcanvas_main_menu li a:hover {\n  color: #2b70fa;\n}\n.offcanvas_main_menu li ul.sub-menu {\n  padding-left: 20px;\n}\n\n.offcanvas_footer {\n  padding-bottom: 50px;\n  text-align: center;\n}\n.offcanvas_footer span a {\n  font-size: 14px;\n  color: #222;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.offcanvas_footer span a:hover {\n  color: #2b70fa;\n}\n\n.offcanvas_menu_wrapper.active .canvas_close {\n  opacity: 1;\n  visibility: visible;\n}\n\n.canvas_close {\n  position: absolute;\n  top: 10px;\n  right: -50px;\n  opacity: 0;\n  visibility: hidden;\n  transition: all linear 0.3s;\n}\n.canvas_close a {\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: 500;\n  width: 40px;\n  height: 40px;\n  display: block;\n  text-align: center;\n  line-height: 40px;\n  border: 1px solid #2b70fa;\n  border-radius: 10px;\n  background: #2b70fa;\n  color: #fff;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.canvas_close a:hover {\n  background: #2b70fa;\n  border-color: #2b70fa;\n  color: #fff;\n}\n\n.canvas_open a {\n  font-size: 26px;\n  width: 50px;\n  height: 42px;\n  display: block;\n  line-height: 39px;\n  text-align: center;\n  border: 1px solid #232323;\n  color: #222;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.canvas_open a:hover {\n  color: #2b70fa;\n  border-color: #2b70fa;\n}\n\n.offcanvas-social {\n  margin-bottom: 40px;\n  margin-top: 40px;\n}\n.offcanvas-social ul li {\n  display: inline-block;\n}\n.offcanvas-social ul li a {\n  height: 40px;\n  width: 40px;\n  text-align: center;\n  line-height: 38px;\n  color: #2b70fa;\n  border: 1px solid #eaeaea;\n  border-radius: 50%;\n  margin: 0 5px;\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n}\n.offcanvas-social ul li a:hover {\n  background: #2b70fa;\n  border-color: #2b70fa;\n  color: #fff;\n}\n\n.toggle-btn {\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  font-size: 20px;\n  color: #0e1133;\n}\n\n.preloader {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 999;\n  background-position: center center;\n  background-repeat: no-repeat;\n /* background-image: url(../../img/icons/preloader.svg);*/\n}\n\n.preloader-close {\n  position: fixed;\n  z-index: 999999;\n  color: #fff;\n  padding: 10px 20px;\n  cursor: pointer;\n  right: 40px;\n  bottom: 40px;\n  font-weight: 600;\n  line-height: 60px;\n  background: #2b70fa;\n  padding: 0 15px;\n  border-radius: 5px;\n}\n\n.loader-wrap {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n}\n\n.loader-wrap .layer-one {\n  position: absolute;\n  left: 0%;\n  top: 0;\n  width: 33.3333%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.loader-wrap .layer-two {\n  position: absolute;\n  left: 33.3333%;\n  top: 0;\n  width: 33.3333%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.loader-wrap .layer-three {\n  position: absolute;\n  left: 66.6666%;\n  top: 0;\n  width: 33.3333%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.loader-wrap .layer .overlay {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #f4f9ff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
